import { useMemo } from 'react';
import { formatToCurrency } from 'utils';
import { calculateMonthlyPayment } from '../helpers';
import { CalculationsValues } from '../useCalculations';

export interface BorrowHook {
  valid: boolean;
  label: string;
  secondLine?: string;
}

export default function useBorrow(values: CalculationsValues): BorrowHook {
  const valid = useMemo(() => values.valid, [values]);

  const label = useMemo(() => {
    if (values.valid) return '';
    const { amount, rate } = values;
    const {
      min_job_value: minJobValue = 0,
      max_job_value: maxJobValue = 500000,
    } = rate;
    if (amount <= minJobValue) return `Min. ${formatToCurrency(minJobValue)}`;
    if (amount >= maxJobValue) return `Max. ${formatToCurrency(maxJobValue)}`;
    return 'Change amount';
  }, [values]);

  const secondLine = useMemo(() => {
    if (values.valid) return undefined;
    const { amount, rate } = values;
    const {
      min_job_value: minJobValue = 0,
      max_job_value: maxJobValue = 500000,
      apr = 0,
      duration = 10,
    } = rate;
    if (amount <= minJobValue) {
      const monthly = calculateMonthlyPayment(apr, duration, minJobValue);
      return `(${formatToCurrency(monthly)} / mo)`;
    }
    if (amount >= maxJobValue) {
      const monthly = calculateMonthlyPayment(apr, duration, maxJobValue);
      return `(${formatToCurrency(monthly)} / mo)`;
    }
    return undefined;
  }, [values]);

  return {
    valid,
    label,
    secondLine,
  };
}
